module.exports = __webpack_public_path__ + "img/2_168.7b89c675.png";